import _ from 'lodash';

export const DEFAULT_PAGE_SIZE = 20;

export default {
  data() {
    return {
      canPaginate: {
        currentPage: 1,
        pageSize: DEFAULT_PAGE_SIZE,
      },
    };
  },
  methods: {
    canPaginateSetCurrentPage(pageNumber) {
      this.canPaginate.currentPage = pageNumber;
    },
    canPaginateSetPageSize(pageSize) {
      this.canPaginate.pageSize = pageSize;
    },
    canPaginateGetPaginatedItems(items, page, pageSize) {
      const pg = page || 1;
      const pgSize = pageSize || 20;
      const res = _.chunk(items, pgSize);
      if (res.length >= pg) {
        return res[pg - 1];
      }
      if (res.length > 0) {
        return res[0];
      }
      return [];
    },
  },
  computed: {
    // Items given to the canPaginate mixin will be given by a computed property
    // named "itemsToPaginate".
    // This way, you can filter/sort your data before applying pagination.
    itemsToPaginate() {
      console.log('[WARN]: You need to set up your itemsToPaginate computed property.');
    },
    totalItemsToPaginate() {
      return this.itemsToPaginate.length;
    },
    paginatedItems() {
      return this.canPaginateGetPaginatedItems(
        this.itemsToPaginate,
        this.canPaginate.currentPage,
        this.canPaginate.pageSize,
      );
    },
  },
};
